<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="26"
    height="26"
    viewBox="0 0 772 752"
    enable-background="new 0 0 772 752"
    xml:space="preserve"
  >
    <path
      :fill="colorHover"
      d="
M488.583344,1.000002
	C489.442657,1.698465 489.720856,2.653537 490.351959,3.058062
	C508.794342,14.879510 527.769897,25.948069 545.578491,38.653164
	C558.667114,47.990906 570.596985,59.073257 582.374939,70.092415
	C593.240112,80.257629 604.121521,90.650650 613.373535,102.238556
	C627.900574,120.433266 642.072266,139.074020 654.572388,158.687134
	C673.976929,189.133530 689.025208,221.891464 699.058838,256.662262
	C704.437012,275.299805 708.457214,294.333374 712.901794,313.232574
	C713.756165,316.865417 713.732727,320.704681 714.208557,325.374847
	C726.679688,306.227814 738.760559,287.679871 751.027039,268.846954
	C758.364380,273.710907 765.326050,278.325897 772.643921,282.970428
	C773.000000,283.000000 773.000000,283.500000 773.000000,283.750000
	C768.005127,291.293213 762.888184,298.506348 758.040588,305.896149
	C747.630127,321.766022 737.220276,337.639801 727.092346,353.689972
	C722.487610,360.987335 718.450256,368.652435 714.367004,376.264160
	C712.807617,379.171021 711.795898,379.494507 708.795715,377.514160
	C679.259705,358.018036 649.571594,338.752167 619.907959,319.449677
	C617.732605,318.034119 615.412354,316.841095 612.827942,315.353851
	C617.441101,308.182220 621.967346,301.145782 627.054688,293.236969
	C647.571350,306.538849 668.025635,319.800323 688.479919,333.061798
	C688.890381,332.685211 689.300842,332.308655 689.711243,331.932068
	C667.780396,194.146713 595.114868,91.733551 473.361969,22.940109
	C476.949585,16.136688 480.803162,8.828972 484.328369,1.260628
	C485.388885,1.000000 486.777802,1.000000 488.583344,1.000002
z"
    />
    <path
      :fill="colorHover"
      d="
M283.416656,753.000000
	C281.194763,751.402710 279.616913,749.380981 277.549377,748.273315
	C254.367447,735.853882 232.704498,721.055969 212.878510,703.943176
	C196.860657,690.117493 182.068832,674.815796 167.279175,659.636841
	C148.381744,640.241943 132.906738,618.113892 118.756935,595.128235
	C104.478546,571.933716 92.174950,547.636047 83.179375,521.905334
	C76.845169,503.787170 71.460114,485.298859 66.527840,466.742828
	C63.375057,454.881531 61.820293,442.595520 59.425453,429.841400
	C47.002598,448.987396 34.772743,467.835968 22.279499,487.090454
	C15.366446,482.824463 8.390121,478.519440 1.206898,474.607239
	C1.000000,473.285645 1.000000,471.571289 1.000001,469.428467
	C2.042830,468.213745 3.406410,467.638092 4.081238,466.610260
	C18.074480,445.295380 32.027637,423.953857 45.898041,402.558838
	C50.384377,395.638672 54.654926,388.576935 58.937756,381.527435
	C60.555386,378.864807 61.942261,377.776978 65.156036,379.905640
	C70.367622,383.357635 76.824280,385.258148 81.345680,389.365417
	C98.302437,404.769073 118.955803,414.628082 137.381180,427.790619
	C144.622543,432.963593 152.285385,437.546600 160.226059,442.703369
	C155.928238,449.485168 151.708313,456.311615 147.206512,462.946777
	C146.824051,463.510468 144.255447,463.272888 143.215103,462.606812
	C125.167160,451.052277 107.202995,439.366913 89.204567,427.734863
	C88.283646,427.139709 87.219139,426.766724 84.831573,425.626526
	C108.028099,562.190430 179.561691,663.158386 299.011902,730.995422
	C295.419800,737.925049 291.706726,745.087952 287.996826,752.625427
	C286.611115,753.000000 285.222198,753.000000 283.416656,753.000000
z"
    />
    <path
      :fill="colorHover"
      d="
M547.973145,188.037537
	C558.388916,201.660446 567.209351,215.923599 572.854126,231.754929
	C577.831421,245.713867 582.498657,259.940002 585.448486,274.425751
	C589.178101,292.740417 589.160400,311.491791 587.000366,330.124359
	C586.233398,336.740356 584.597229,343.281464 584.211853,349.906403
	C583.971619,354.036743 585.833862,358.254913 585.876587,362.442566
	C586.007141,375.247467 585.518616,388.058624 585.649414,400.863525
	C585.747803,410.495605 586.460388,420.120514 586.842651,429.750885
	C587.262634,440.332367 587.867493,450.914398 587.954285,461.499756
	C588.240173,496.372253 578.576233,528.457153 561.237671,558.605347
	C551.043213,576.331299 538.534729,592.079346 523.569580,605.770691
	C498.157410,629.019897 468.583496,644.713074 435.061432,653.065918
	C413.842834,658.353027 392.253601,659.191650 370.745514,657.743713
	C347.852814,656.202698 325.799347,650.222717 304.798676,640.478699
	C289.021088,633.158020 274.303589,624.200623 260.943329,613.222778
	C242.509293,598.075928 227.144043,580.150757 215.068802,559.467346
	C202.786087,538.428528 193.711182,516.013489 190.414856,491.959381
	C188.068542,474.837769 188.386993,457.311737 188.174622,439.958160
	C188.100082,433.865967 190.226593,427.775024 190.870605,421.633423
	C191.169876,418.779327 190.112305,415.810974 190.039627,412.885223
	C189.631790,396.468964 189.191132,380.050659 189.104065,363.631256
	C189.081909,359.450226 190.739944,355.272705 190.837143,351.075287
	C190.942612,346.520294 190.339203,341.912933 189.675888,337.382477
	C187.269058,320.944031 187.566727,304.510162 188.876968,287.993988
	C190.132324,272.169739 193.729767,256.940857 198.978195,242.042725
	C206.378418,221.036438 217.154037,201.969925 230.931000,184.415634
	C248.855743,161.576309 270.904999,143.805939 296.395569,130.408752
	C313.182312,121.586067 331.195068,115.708305 349.870178,111.970093
	C368.179993,108.304993 386.741760,108.112053 405.156006,109.246780
	C424.774658,110.455727 443.880371,115.167358 462.217682,122.635735
	C482.871704,131.047668 502.120514,141.841705 518.432922,157.119629
	C528.749512,166.781967 538.115845,177.458923 547.973145,188.037537
M274.447754,176.987869
	C273.146729,177.980148 271.738800,178.860214 270.561157,179.982010
	C258.605835,191.370316 248.101639,203.887695 239.310699,217.957092
	C221.851486,245.899597 213.953796,276.577576 213.318924,309.110718
	C213.101318,320.263062 215.145859,331.565552 217.095566,342.634094
	C222.741776,374.687836 237.371017,402.497101 259.106812,426.445404
	C276.474670,445.581146 297.263123,460.075897 321.229950,470.143860
	C342.718475,479.170746 365.165924,483.126038 388.199097,483.723602
	C397.432587,483.963135 406.740204,482.111725 415.985107,480.976166
	C431.715668,479.044067 446.641357,474.124207 460.909912,467.474487
	C484.062927,456.684235 504.043335,441.637360 520.621399,422.022430
	C534.422791,405.692749 545.036865,387.694672 552.216858,367.537720
	C559.556824,346.931702 562.664307,325.857086 562.184326,303.968079
	C561.854614,288.927277 559.648865,274.317291 555.440308,260.038239
	C548.378296,236.077744 536.655212,214.624893 520.290100,195.565460
	C506.192078,179.146332 489.755920,165.779114 470.873505,155.517990
	C451.487579,144.983246 430.823517,137.798584 408.683502,136.109329
	C395.983459,135.140350 383.101990,134.242691 370.467560,135.296021
	C354.175934,136.654282 338.237244,140.790833 323.011902,147.051956
	C305.430298,154.281998 289.198669,163.768875 274.447754,176.987869
M533.545959,553.957703
	C539.236755,542.914551 545.266785,532.030029 550.526489,520.785217
	C556.204346,508.646637 560.417236,489.922089 559.335571,485.874084
	C518.517639,546.627930 462.393646,580.804749 388.038483,580.816589
	C313.545288,580.828369 257.301147,546.557251 215.871429,485.554901
	C217.216721,492.949707 218.802414,500.287201 220.886215,507.480377
	C227.903442,531.703735 240.062943,553.036804 256.512695,572.188293
	C271.158630,589.239685 288.520691,602.559082 308.243439,613.028137
	C328.098053,623.567322 349.376434,629.954590 371.622406,631.730652
	C389.176483,633.132263 406.993561,632.889099 424.350159,628.806274
	C447.556824,623.347351 469.114288,614.198914 488.660248,600.210205
	C506.279572,587.600464 521.087769,572.489746 533.545959,553.957703
M310.525513,493.998749
	C271.803284,477.659912 241.324905,451.500580 217.916550,416.717743
	C228.975266,467.184875 255.940598,507.079315 301.389160,531.688171
	C373.737488,570.862305 441.984100,561.455017 505.707397,510.038177
	C526.136719,493.554321 560.685791,434.114105 557.369324,416.531677
	C546.431946,433.231567 533.637695,448.206390 518.422729,461.229218
	C501.443054,475.762604 482.662323,487.092346 462.016785,495.473999
	C443.845428,502.851196 424.883148,507.545715 405.434814,508.745758
	C386.856445,509.892120 367.991394,510.294250 349.699982,505.835571
	C336.718292,502.671143 324.096100,498.031921 310.525513,493.998749
z"
    />
    <path
      :fill="colorHover"
      d="
M343.044067,388.991211 
	C330.495575,380.132111 321.911713,368.727936 317.651794,354.214172 
	C317.017731,352.053833 316.475037,349.866730 315.746002,347.156250 
	C324.403656,346.151123 332.778503,345.178833 341.720947,344.140656 
	C346.862091,363.715424 358.805206,376.857666 379.999390,380.924408 
	C379.999390,369.331421 379.999420,357.881744 379.999390,346.432068 
	C379.999390,339.600739 379.856873,332.765045 380.065247,325.940094 
	C380.156281,322.957855 379.191528,321.802429 376.275208,320.853668 
	C364.429169,316.999695 352.458038,312.997345 342.817566,304.811798 
	C333.619873,297.002197 327.769348,287.232971 326.880096,274.545441 
	C325.126740,249.529953 344.138214,231.799683 365.465424,226.990906 
	C370.189087,225.925812 374.902771,224.816483 380.012115,223.637253 
	C380.012115,215.301758 380.012115,206.868469 380.012115,198.222229 
	C386.010132,198.222229 391.626129,198.222229 397.999634,198.222229 
	C397.999634,205.314667 398.101929,212.563293 397.953003,219.806732 
	C397.886475,223.044388 398.372833,224.556320 402.308044,225.281891 
	C416.717194,227.938629 429.399506,234.405853 439.551086,245.136093 
	C446.258331,252.225616 450.814697,260.545776 452.246918,270.860474 
	C444.189911,271.710205 436.570831,272.513763 428.941833,273.318359 
	C422.860779,259.209991 414.864075,247.647614 397.999664,244.451218 
	C397.999664,250.170883 397.999634,255.267838 397.999695,260.364777 
	C397.999786,271.861420 398.163116,283.361755 397.901276,294.852417 
	C397.822021,298.329956 398.899963,299.754150 402.175873,300.701569 
	C414.488586,304.262512 426.500061,308.701080 437.104706,316.081177 
	C450.715057,325.553009 458.347046,338.668915 456.807129,355.351044 
	C455.001587,374.910767 443.706818,388.454041 425.783234,395.776276 
	C417.205078,399.280670 407.819153,400.807709 398.102386,403.417450 
	C398.102386,411.313049 398.102386,420.399170 398.102386,429.737976 
	C391.948151,429.737976 386.216492,429.737976 379.999390,429.737976 
	C379.999390,422.030426 379.829102,414.412628 380.071442,406.807953 
	C380.192108,403.021332 379.285828,401.499634 375.112732,400.834015 
	C363.832520,399.034698 352.962799,395.691406 343.044067,388.991211 
M404.943848,329.433167 
	C402.692383,328.761566 400.440918,328.089966 398.320526,327.457489 
	C398.320526,345.762421 398.320526,363.831146 398.320526,383.358765 
	C405.503845,380.690216 412.704071,379.438202 418.218140,375.699402 
	C434.588654,364.599365 434.163452,345.402771 418.114258,336.063110 
	C414.098877,333.726349 409.747833,331.966339 404.943848,329.433167 
M352.980438,266.326019 
	C351.368134,271.370544 352.892517,276.007202 355.639465,280.012390 
	C361.389771,288.396606 370.690247,290.868652 379.765076,294.086060 
	C379.765076,277.074677 379.765076,260.622192 379.765076,243.723404 
	C377.081268,244.190552 374.676758,244.489227 372.330933,245.038467 
	C362.841858,247.260147 353.778778,256.891846 352.980438,266.326019 
z"
    />
  </svg>
</template>

<script>
export default {
  name: "CurrencyIcon",
  props: {
    colorHover: {
      required: false,
      type: String,
      default: "var(--textinactive)"
    }
  }
};
</script>
